export const COOKIES_DIALOG = 'cookiesDialog';
export const ERROR_MESSAGE = 'errorMessage';
export const NO_PROVIDER = 'noProvider';
export const CHECK_CONNECTION_ERROR = 'noProvider';
export const GENERIC_ERROR = 'genericError';
export const VERSION = 'version';
export const DELETE_COMPLAINT = 'deleteComplaint';
export const DELETE_FRAUD = 'deleteFraud';
export const TOKEN_EXPIRED = 'tokenExpired';
export const SEND_TO_REVIEW = 'sendToReview';
